import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import { createNotification } from "../../../shared/store/notifications";

export const gradeStudent = ({ enrollmentId, grade }) => {
  const body = new FormData();
  body.append(
    "dados",
    JSON.stringify([{ matriculaid: enrollmentId, nota_final: grade }])
  );
  return axios.middleware.post(
    // "/Backend.asmx/BK_Atualiza_Situacao",
    "/Backend.asmx/BK_Atualiza_Nota_Final",
    body
  );
};

export const useGradeStudent = ({ config } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...config,
    mutationFn: gradeStudent,
    onSuccess: () => {
      createNotification({
        type: "success",
        message: "Aluno avaliado com sucesso",
      });
      queryClient.invalidateQueries({ queryKey: ["studentStats"] });
      queryClient.invalidateQueries({ queryKey: ["studentEnrollmentData"] });
      queryClient.invalidateQueries({ queryKey: ["diaryCourse"] });
    },
  });
};
